import { isStagingRuntime } from '../../runtime/env';

export function getNinetyNineHostKey(): string {
    return isStagingRuntime() ? 'dev' : '99designs.com';
}
